import Vue from 'vue'
import moment from 'moment'
import { registerAdditionalExamModule } from '@/store/registerModule'
import {
  hasVisibleHtmlText,
  isValidMedicalRecordValue
} from '@/utils/medicalRecordValue'

// Reexportados: os consumidores antigos continuam importando daqui.
export { hasVisibleHtmlText, isValidMedicalRecordValue }

/** Status de consulta considerados abertos (modal de anotações pode abrir automaticamente) */
export const ATTENDANCE_OPEN_STATUSES = ['OPENED', 'PAUSED']

export const summaryTypes = [
  'antecedentes-oftalmologicos',
  'cirurgias-oftalmologicas-anteriores',
  'alergias',
  'antecedentes-pessoais',
  'outros-medicamentos-em-uso',
  'medicamentos-oftalmologicos-em-uso',
  'antecedentes-familiares'
]

export const addAdditionalExamsToForm = attendance => {
  attendance &&
    attendance.medicalRecords.map(medicalRecord => {
      if (!medicalRecord.type.includes('exame-personalizado')) return
      registerAdditionalExamModule(
        medicalRecord.type,
        medicalRecord.value.customName,
        true
      )
    })
}

export const addAdditionalExamsFromForms = (id, name, status) => {
  registerAdditionalExamModule(id, name, status)
}

export const populateMedicalRecords = (
  canEdit,
  attendance,
  form,
  patientSummaries
) => {
  const safeAttendanceType = attendance?.type ?? null

  if (canEdit && safeAttendanceType === 'ATTENDANCE') {
    Object.keys(form).map(key => {
      if (form[key] && form[key].id) {
        form[key] = getMedicalRecordOrSummary(
          attendance,
          form[key],
          key,
          patientSummaries
        )
      }
    })
  }

  const medicalRecordsArray = Array.isArray(attendance?.medicalRecords)
    ? attendance.medicalRecords
    : []
  const medicalRecordsMap = medicalRecordsArray.reduce((acc, medicalRecord) => {
    if (medicalRecord && medicalRecord.type) {
      acc[medicalRecord.type] = medicalRecord.value
    }
    return acc
  }, {})

  Object.keys(form).map(key => {
    if (
      form[key] &&
      typeof form[key] === 'object' &&
      form[key].id &&
      medicalRecordsMap[form[key].id]
    ) {
      const medicalRecordValue = medicalRecordsMap[form[key].id]
      const type = !Array.isArray(medicalRecordValue) ? 'fields' : 'value'
      if (isValidMedicalRecordValue(medicalRecordValue)) {
        form[key] = {
          ...form[key],
          showing: true,
          opened: true,
          completed:
            isNotEmptyArray(medicalRecordValue) ||
            hasSomeField(medicalRecordValue),
          [type]: medicalRecordValue
        }
      }
    }
  })

  return form
}

const getMedicalRecordOrSummary = (attendance, form, key, patientSummaries) => {
  if (!form || !form.id) return form
  const medicalRecord = (
    Array.isArray(attendance?.medicalRecords) ? attendance.medicalRecords : []
  ).find(mr => mr && mr.type === form.id)
  if (!medicalRecord && summaryTypes.includes(form.id)) {
    const summaryItems = filterSummaryItem(form.id, patientSummaries)
    if (summaryItems.length) {
      form = {
        ...form,
        summary: true,
        showing: true,
        opened: true,
        completed: true,
        value: fillSummaryData(summaryItems, form.id)
      }
    }
  }
  return form
}

const filterSummaryItem = (key, patientSummaries) => {
  const list = Array.isArray(patientSummaries) ? patientSummaries : []
  return list.filter(item => item && item.type === key)
}

const fillSummaryData = (summaryItems, type) => {
  return summaryItems.reduce((acc, summary) => {
    if (!summary.medical_record) {
      acc.push(getDefaultByType(summary))
      return acc
    }

    summary.medical_record.value.map(medicalRecord => {
      !acc.some(el => JSON.stringify(el) === JSON.stringify(medicalRecord)) &&
        acc.push(medicalRecord)
    })
    return acc
  }, [])
}

const getDefaultByType = summary => {
  switch (summary.type) {
    case 'antecedentes-pessoais':
      return {
        antecedente: summary.name,
        ano: null,
        custom: null
      }
    case 'antecedentes-oftalmologicos':
      return {
        antecedente: summary.name,
        situacao: null,
        ultimaAtualizacao: moment().format('DD/MM/YYYY')
      }
    case 'cirurgias-oftalmologicas-anteriores':
      return {
        cirurgia: summary.name,
        data: null
      }
    case 'alergias':
      return {
        alergia: summary.name,
        comentario: null
      }
    case 'outros-medicamentos-em-uso':
      return {
        medicamento: summary.name,
        emUso: true
      }
    case 'antecedentes-familiares':
      return {
        antecedente: summary.name,
        familiar: []
      }
  }
}

const hasSomeField = fields => {
  return Object.keys(fields).some(
    key => isNotEmptyArray(fields[key]) || isNotEmptyField(fields[key])
  )
}

const isNotEmptyArray = data => {
  return Array.isArray(data) && data.length
}

const isNotEmptyField = field => {
  return !Array.isArray(field) && field !== undefined && field !== null
}

export const gotToOption = moduleId => {
  const closeOpenModals = () => {
    try {
      if (Vue.prototype.$bvModal) {
        const modals = [
          'attendance-review-modal',
          'pause-modal',
          'direct-patient-modal'
        ]
        modals.forEach(modalId => {
          try {
            Vue.prototype.$bvModal.hide(modalId)
          } catch (e) {
            const modalElement = document.getElementById(modalId)
            if (modalElement && modalElement.classList.contains('show')) {
              const closeButton =
                modalElement.querySelector('[aria-label="Close"]') ||
                modalElement.querySelector('.close')
              if (closeButton) {
                closeButton.click()
              }
            }
          }
        })
      }

      const body = document.body
      if (body && body.classList.contains('modal-open')) {
        body.classList.remove('modal-open')
        body.style.overflow = ''
        body.style.paddingRight = ''
      }

      const backdrop = document.querySelector('.modal-backdrop')
      if (backdrop) {
        backdrop.remove()
      }
    } catch (error) {
      console.warn('Erro ao fechar modais:', error)
    }
  }

  const tryScroll = (attempts = 0) => {
    const element = document.getElementById(`module-wrapper-${moduleId}`)

    if (!element) {
      if (attempts < 15) {
        setTimeout(() => tryScroll(attempts + 1), 100)
        return
      }
      Vue.prototype.$toast.warning('Adicione este item à consulta para navegar')
      return
    }

    const body = document.body
    if (body && body.classList.contains('modal-open')) {
      body.classList.remove('modal-open')
      body.style.overflow = ''
      body.style.paddingRight = ''
    }

    const formSlot = document.querySelector('.form-slot')
    if (formSlot) {
      const offset = 300
      try {
        formSlot.scrollTo({
          top: element.offsetTop - offset,
          behavior: 'smooth'
        })
      } catch (error) {
        formSlot.scrollTop = element.offsetTop - offset
      }
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }, 100)
      return
    }

    const formsContainer = document.getElementById('forms-container')
    if (formsContainer) {
      try {
        formsContainer.scrollTo({
          top: element.offsetTop - window.innerHeight / 3,
          behavior: 'smooth'
        })
      } catch (error) {
        formsContainer.scrollTop = element.offsetTop - window.innerHeight / 3
      }
      return
    }

    element.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  closeOpenModals()

  requestAnimationFrame(() => {
    setTimeout(() => {
      setTimeout(() => tryScroll(), 400)
    }, 300)
  })
}

export const validateCidAndScroll = (attendance, form, store) => {
  if (!attendance) return true

  const attendanceType = attendance.type
  if (!['ATTENDANCE', 'SURGERY'].includes(attendanceType)) {
    return true
  }

  if (!form) return false

  const cidMr = attendance.medicalRecords?.find(el => el.type === 'cid')
  const cidForm = form.cid

  let hasCid = false

  // 1) Verifica CID vindo de medicalRecords (histórico do atendimento)
  if (cidMr && cidMr.value) {
    const value = cidMr.value

    if (Array.isArray(value)) {
      hasCid = value.length > 0
    } else if (typeof value === 'string') {
      hasCid = value.trim().length > 0
    } else if (typeof value === 'object' && value !== null) {
      hasCid = Object.keys(value).length > 0
    }
  }

  // 2) Se ainda não encontrou, verifica o formulário atual (form.cid)
  if (!hasCid && cidForm) {
    if (cidForm.value) {
      if (Array.isArray(cidForm.value)) {
        hasCid =
          cidForm.value.length > 0 &&
          cidForm.value.some(item => item && (item.cid || item))
      } else if (typeof cidForm.value === 'string') {
        hasCid = cidForm.value.trim().length > 0
      } else if (typeof cidForm.value === 'object' && cidForm.value !== null) {
        hasCid = Object.keys(cidForm.value).length > 0
      }
    }

    // fallback: alguns modelos podem armazenar em fields
    if (!hasCid && cidForm.fields) {
      const fields = cidForm.fields
      hasCid = Object.keys(fields).some(
        key => fields[key] && fields[key].toString().trim().length > 0
      )
    }
  }

  // Se já tem CID em algum lugar, libera a finalização
  if (hasCid) {
    return true
  }

  // Sem CID: aplica aviso + scroll
  Vue.prototype.$toast.warning('Informe um CID antes de finalizar')

  if (cidForm && store) {
    const tryDispatch = (path, payload) => {
      try {
        store.dispatch(path, payload, { root: true })
        return true
      } catch (e) {
        return false
      }
    }

    if (!cidForm.showing) {
      tryDispatch('attendanceStore/form/cid/handleProps', {
        key: 'showing',
        value: true
      }) ||
        tryDispatch('attendance/form/cid/handleProps', {
          key: 'showing',
          value: true
        })
    }
    if (!cidForm.opened) {
      tryDispatch('attendanceStore/form/cid/handleProps', {
        key: 'opened',
        value: true
      }) ||
        tryDispatch('attendance/form/cid/handleProps', {
          key: 'opened',
          value: true
        })
    }
    tryDispatch('attendanceStore/form/handleActiveModule', 'cid') ||
      tryDispatch('attendance/form/handleActiveModule', 'cid')
  }

  Vue.nextTick(() => {
    setTimeout(() => {
      gotToOption('cid')
    }, 400)
  })

  return false
}

export const translateType = type => {
  switch (type) {
    case 'ATTENDANCE':
      return 'Consulta'
    case 'PRE_CONSULTATION':
      return 'Pré-consulta'
    case 'MEDICAL_REPORT':
      return 'Laudo médico'
    case 'SURGERY':
      return 'Consulta cirúrgica'
    case 'ANESTHETIST_EVOLUTION':
      return 'Evolução do anestesista'
    case 'TEAM_EVOLUTION':
      return 'Evolução da equipe multidisciplinar'
    case 'TEAM_ANNOTATIONS':
      return 'Anotações da equipe multidisciplinar'
    case 'EXAM':
      return 'Exame'
    default:
      return 'Consulta'
  }
}

export const startAttendanceByValidation = (attendanceId, patientId) => {
  // Consulta 3.0 é a única versão — flag enable_new_attendance descontinuado
  Vue.prototype.router
    .push(`/attendance/${attendanceId}/patient/${patientId}`)
    .catch(err => {
      // Handle navigation errors silently
      if (err.name !== 'NavigationDuplicated') {
        console.warn('Navigation error:', err)
      }
    })
}

export const startAttendanceByEnvValidation = (attendanceId, patientId) => {
  // Consulta 3.0 é a única versão — flag enable_new_attendance descontinuado
  Vue.prototype.router
    .push(`/attendance/${attendanceId}/patient/${patientId}`)
    .catch(err => {
      // Handle navigation errors silently
      if (err.name !== 'NavigationDuplicated') {
        console.warn('Navigation error:', err)
      }
    })
}

export const startPreConsultationByEnvValidation = (
  attendanceId,
  patientId
) => {
  // Consulta 3.0 é a única versão — flag enable_new_attendance descontinuado
  Vue.prototype.router
    .push(`/attendance/${attendanceId}/patient/${patientId}`)
    .catch(err => {
      // Handle navigation errors silently
      if (err.name !== 'NavigationDuplicated') {
        console.warn('Navigation error:', err)
      }
    })
}

/**
 * Destino do botão "Ver exame" no Prontuário.
 * EXAM foi migrado para o shell React 3.0 (mesma rota usada ao iniciar o exame,
 * ver startExamByEnvValidation acima). ESSILOR_ATTENDANCE permanece na rota
 * legada porque o shell 3.0 não habilita o painel Essilor para esse tipo.
 */
export const examViewTarget = (type, attendanceId, patientId) => {
  if (type === 'EXAM') {
    return `/attendance/${attendanceId}/patient/${patientId}`
  }
  if (type === 'ESSILOR_ATTENDANCE') {
    return `/pacientes/${patientId}/exame/${attendanceId}`
  }
  return null
}

export const startExamByEnvValidation = (attendanceId, patientId) => {
  // Consulta 3.0 é a única versão — flag enable_new_attendance descontinuado
  Vue.prototype.router
    .push(`/attendance/${attendanceId}/patient/${patientId}`)
    .catch(err => {
      // Handle navigation errors silently
      if (err.name !== 'NavigationDuplicated') {
        console.warn('Navigation error:', err)
      }
    })
}

export const startSurgeryByEnvValidation = (
  attendanceId,
  patientId,
  type,
  surgeryId
) => {
  // Consulta 3.0 é a única versão — flag enable_new_attendance descontinuado
  Vue.prototype.router
    .push(
      `/attendance/${attendanceId}/patient/${patientId}?surgeryId=${surgeryId}`
    )
    .catch(err => {
      // Handle navigation errors silently
      if (err.name !== 'NavigationDuplicated') {
        console.warn('Navigation error:', err)
      }
    })
}

export const openAttendanceOnNewTab = (attendanceId, patientId) => {
  // Consulta 3.0 é a única versão — flag enable_new_attendance descontinuado
  window.open(`/attendance/${attendanceId}/patient/${patientId}`, '_blank')
}

/**
 * Indica se um HTML do editor de texto tem texto visível.
 * '<p><br></p>', '<p>&nbsp;</p>' e afins contam como vazio.
 */
